import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
var _excluded = ["active", "children", "compact", "fullWidth", "textColorMode"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { BUTTON__CONTENT_CLASS } from "../constants";
import { buttonContentTextColor } from "../styles/base.styles";
import { buttonSize } from "../styles/buttonSizes.styles";
import * as styles from "./OutlineButton.styles";
export var OutlineButtonLink = function OutlineButtonLink(_ref) {
  var active = _ref.active,
    children = _ref.children,
    _ref$compact = _ref.compact,
    compact = _ref$compact === void 0 ? false : _ref$compact,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    _ref$textColorMode = _ref.textColorMode,
    textColorMode = _ref$textColorMode === void 0 ? 'brand' : _ref$textColorMode,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledA, _extends({
    "data-is-active": active
  }, props, {
    $_css: [styles.outlineButtonLink, buttonSize(compact, fullWidth)]
  }), /*#__PURE__*/React.createElement(_StyledDiv, {
    className: BUTTON__CONTENT_CLASS,
    $_css2: buttonContentTextColor[textColorMode]
  }, children));
};
var _StyledA = _styled("a")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv = /*#__PURE__*/_styled2("div").withConfig({
  displayName: "OutlineButtonLink___StyledDiv",
  componentId: "sc-1bqi0sd-0"
})(["", ""], function (p) {
  return p.$_css2;
});